<template>
  <vue-highcharts type="chart" :options="options" class="custom-minutes" />
</template>
<script>
import { mapGetters } from 'vuex'
import VueHighcharts from 'vue3-highcharts'
export default {
  name: 'active-profile-history-chart',
  components: {
    VueHighcharts,
  },
  props: {
    isReport: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('usercardio', ['memberProfileHistory']),
    categories() {
      let _data = []
      if (this.memberProfileHistory) {
        _data = this.memberProfileHistory.history.Categories
      }
      return _data
    },
    inzone() {
      let _data = []
      if (this.memberProfileHistory) {
        _data = this.memberProfileHistory.history.InZone
      }
      return _data
    },
    inzoneGoals() {
      let _data = []
      if (this.memberProfileHistory) {
        _data = this.memberProfileHistory.history.InZoneGoals
      }
      return _data
    },
    abovezone() {
      let _data = []
      if (this.memberProfileHistory) {
        _data = this.memberProfileHistory.history.AboveZone
      }
      return _data
    },
    abovezoneGoals() {
      let _data = []
      if (this.memberProfileHistory) {
        _data = this.memberProfileHistory.AboveZoneGoals
      }
      return _data
    },
    options() {
      var chartWidth = 1100
      var doAnimation = true
      if (this.isReport !== undefined && this.isReport !== null) {
        if (this.isReport === '1') doAnimation = false
      }
      let _options = {
        chart: {
          backgroundColor: null,
          borderWidth: 0,
          type: 'column',
          width: chartWidth,
          height: 300,
          style: {
            overflow: 'visible',
          },
          animation: doAnimation,
        },
        title: {
          text: 'Active Minutes',
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: this.categories,
        },
        yAxis: [
          {
            min: 0,
            title: {
              text: 'minutes',
            },
          },
        ],
        legend: {
          enabled: false,
        },
        tooltip: {
          shared: true,
          valueDecimals: 0,
        },
        plotOptions: {
          column: {
            grouping: false,
            shadow: false,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: 'In Zone Goal',
            data: this.inzoneGoals,
            pointPadding: 0.3,
            pointPlacement: -0.2,
            color: '#CBE1F4',
            animation: doAnimation,
          },
          {
            name: 'In Zone',
            data: this.inzone,
            pointPadding: 0.4,
            pointPlacement: -0.2,
            color: '#004C72',
            animation: doAnimation,
          },
          {
            name: 'Above Zone Goal',
            data: this.abovezoneGoals,
            pointPadding: 0.3,
            pointPlacement: 0.2,
            color: '#FFD2A5',
            animation: doAnimation,
          },
          {
            name: 'Above Zone',
            data: this.abovezone,
            pointPadding: 0.4,
            pointPlacement: 0.2,
            color: '#F87712',
            animation: doAnimation,
          },
        ],
      }
      return _options
    },
  },
}
</script>
<style scoped>
.custom-weekly-goal {
  width: 100%;
  height: 250px;
  margin: 0 auto;
}
</style>
